import { render, staticRenderFns } from "./ItemCollectionDetailItem.vue?vue&type=template&id=45e2a13c&scoped=true&"
import script from "./ItemCollectionDetailItem.vue?vue&type=script&lang=js&"
export * from "./ItemCollectionDetailItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e2a13c",
  null
  
)

export default component.exports